module.exports = __webpack_public_path__ + "static/img/a37c5328fd441980b0fda36aba1d0384.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index_pro1.png
// module id = PzRI
// module chunks = 1